(function () {
	'use strict';

	angular.module('mx.components').directive('mxRepeaterComplete', [
		'$timeout',
		'$parse',
		function mxRepeaterCompleteDirective($timeout, $parse) {
			return {
				restrict: 'A',
				link: function (scope, element, attr) {
					if (scope.$last === true) {
						$timeout(function () {
							$parse(attr.mxRepeaterComplete)(scope);
						});
					}
				},
			};
		},
	]);
})();
